module.exports = __webpack_public_path__ + "img/icon-note.1f5509a8.svg";